import SearchParamsBase from '../../Elements/SearchParamsBase';
import InputTypesEnum from '../../Enums/InputTypesEnum';

export default class EndOfMonthSearchParams extends SearchParamsBase {
  initialize() {
    this.RevenuePeriod = '';
    this.IsApproved = '';
  }

  static fieldsInSearchBox = [
    { fieldName: 'RevenuePeriod', label: 'Revenue Period', className: 'col-4', type: InputTypesEnum.Text },
    { fieldName: 'IsApproved', label: 'Approved?', className: 'col-4', type: InputTypesEnum.EmptyYesNoSelect },
  ];

  static iconName = 'fa-solid fa-search';
  static saveType = 'EndOfMonthSearchParams';

  static ConvertToJSON(originalSearchItem) {
    const correctedSearchItem = { ...originalSearchItem };

    for (const prop in correctedSearchItem) {
      correctedSearchItem[prop] = correctedSearchItem[prop].toString();
    }
    return JSON.stringify(correctedSearchItem);
  }
}
